import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import HttpManager from "../../../../services/HttpManager";
import { ProspectCatalogs } from "../../../../services/v2/prospects.service";
import { Regla } from "../../../../services/v2/telefonia.service";
import { EditorCampana, nuevaCampana } from "../../sales/campanasView";
import { Aviso, Check, cuando, errorTexto, plantelNombre } from "./comunes";
import { Compartido } from "./telefoniaController";

const DIAS = [[1, "L"], [2, "M"], [3, "Mi"], [4, "J"], [5, "V"], [6, "S"], [7, "D"]] as [number, string][];

/**
 * Campañas automáticas: una regla con los mismos filtros de una campaña del auto-marcador, que cada día a la hora
 * dicha arma la campaña sola (termina la de ayer, activa la de hoy). Supervisión deja de armarlas a mano.
 */
const CampanasAuto: React.FC<{ sh: Compartido }> = ({ sh }) => {
	const http = HttpManager.getInstance();
	const navigate = useNavigate();
	const [reglas, setReglas] = useState<Regla[]>([]);
	const [catalogs, setCatalogs] = useState<ProspectCatalogs | null>(null);
	const [edit, setEdit] = useState<any | null>(null);
	const [error, setError] = useState<string | null>(null);
	const [aviso, setAviso] = useState<string | null>(null);
	useEffect(() => {
		http.telefoniaService.reglas(sh.campusId).then((r) => setReglas(r.data.reglas)).catch((e) => setError(errorTexto(e)));
		http.prospectsService.catalogs(sh.campusId).then((r) => setCatalogs(r.data)).catch(() => undefined);
	}, [sh.campusId]);

	const correr = async (r: Regla) => {
		try { const x = await http.telefoniaService.correrRegla(sh.campusId, r.id); setReglas(x.data.reglas); setAviso(x.data.campaign ? "Campaña armada: " + x.data.campaign.name + " con " + x.data.campaign.contacts_total + " personas." : "Corrió, pero con esos filtros no había a quién llamar."); }
		catch (e) { setError(errorTexto(e)); }
	};
	const borrar = async (r: Regla) => {
		if (!window.confirm("¿Borrar la regla " + r.name + "? Las campañas ya armadas se quedan.")) return;
		try { setReglas((await http.telefoniaService.borrarRegla(sh.campusId, r.id)).data.reglas); } catch (e) { setError(errorTexto(e)); }
	};
	const apagar = async (r: Regla) => {
		try { setReglas((await http.telefoniaService.guardarRegla(sh.campusId, r.id, { ...r, bool_enabled: !r.bool_enabled })).data.reglas); } catch (e) { setError(errorTexto(e)); }
	};

	return (
		<>
			<div className="tf-filtros">
				<span className="nu-tenue">Cada regla arma una campaña del auto-marcador todos los días a la hora que digas (hora de México). Las asesoras la ven en CRM → Herramientas → Auto-marcador.</span>
				<span style={{ flex: 1 }} />
				<button className="nu-btn pri" onClick={() => setEdit({ ...nuevaCampana(), run_at: "08:00", days: [1, 2, 3, 4, 5], bool_enabled: true, campus_id: sh.campusId })}>+ Nueva regla</button>
			</div>
			<Aviso texto={error} onClose={() => setError(null)} /><Aviso texto={aviso} tipo="ok" onClose={() => setAviso(null)} />
			<div className="tf-lista">
				{reglas.map((r) => (
					<div key={r.id} className={"tf-item" + (r.bool_enabled ? "" : " apagado")}>
						<div>
							<h4>{r.name} <span className="nu-tenue">· {plantelNombre(sh.cat, r.campus_id)}</span>{!r.bool_enabled ? <span className="tf-chip gris" style={{ marginLeft: 8 }}>apagada</span> : null}</h4>
							<div className="tf-meta"><span>Se arma a las {r.run_at} · {DIAS.filter(([d]) => (r.days || []).includes(d)).map(([, t]) => t).join(" ")}</span><span className="tf-chip">{r.mode === "grupal" ? "grupal" : "personal"}</span><span className="tf-chip">{r.pacing === "automatico" ? "automático" : "vista previa"}</span></div>
							<div className="tf-desc">{r.last_campaign_id ? <><b>Última:</b> {r.campana} · {r.campana_total ?? 0} personas · {r.campana_status} · {cuando(r.last_run_at)} <button className="nu-btn chico" onClick={() => navigate("/prospects")}>Ver en Auto-marcador</button></> : <span className="nu-tenue">Todavía no ha corrido.</span>}</div>
						</div>
						<div className="tf-acciones">
							<button className="nu-btn chico" onClick={() => correr(r)}>Armar ahora</button>
							<button className="nu-btn chico" onClick={() => setEdit({ ...nuevaCampana(), ...r, filters: { ...nuevaCampana().filters, ...(r.filters || {}) }, schedule: r.schedule || nuevaCampana().schedule, retry: r.retry || nuevaCampana().retry, weights: r.weights || nuevaCampana().weights })}>Editar</button>
							<button className="nu-btn chico" onClick={() => apagar(r)}>{r.bool_enabled ? "Apagar" : "Encender"}</button>
							<button className="nu-btn chico" onClick={() => borrar(r)}>Borrar</button>
						</div>
					</div>
				))}
				{!reglas.length ? <div className="nu-vacio">Sin reglas. Ejemplo: "Pre-inscritos sin llamada", todos los días a las 8:00, para todo el equipo.</div> : null}
			</div>
			{edit ? (
				<EditorCampana campusId={sh.campusId} catalogs={catalogs} valor={edit} onClose={() => setEdit(null)} onGuardada={() => undefined}
					titulo={edit.id ? "Editar regla" : "Nueva regla automática"} textoGuardar="Guardar regla"
					extra={(v, set) => (
						<div className="tarjeta">
							<h4>Cuándo se arma</h4>
							<div className="cp-dos">
								<div><label>Hora (México)</label><input type="time" value={v.run_at} onChange={(e) => set("run_at", e.target.value)} /></div>
								<div><label>Días</label><div className="cp-chips">{DIAS.map(([d, t]) => <button key={d} type="button" className={"nu-btn chico" + ((v.days || []).includes(d) ? " pri" : "")} onClick={() => set("days", (v.days || []).includes(d) ? v.days.filter((x: number) => x !== d) : [...(v.days || []), d])}>{t}</button>)}</div></div>
							</div>
							<Check checked={!!v.bool_enabled} onChange={(b) => set("bool_enabled", b)}>Encendida</Check>
						</div>
					)}
					onGuardar={async (payload) => { setReglas((await http.telefoniaService.guardarRegla(sh.campusId, edit.id || null, payload)).data.reglas); setEdit(null); setAviso("Regla guardada."); }} />
			) : null}
		</>
	);
};

export default CampanasAuto;
